import React from 'react';
import { Grid, Switch, Typography } from '@material-ui/core';

export default function TransitionSwitch(props) {
  const [state, setState] = React.useState({ checked: true })

  const handleChange = () => {
    setState({checked: !state.checked});
    props.onTransitionChange();
  }

  return (
      <Grid
        container
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Typography variant='subtitle2'>
            TRANSITIONS
          </Typography>
        </Grid>
        <Grid item>
          <Switch
            checked={state.checked} 
            onChange={handleChange}
            color="primary"
          />
        </Grid>
      </Grid>
  );
}